import { useEffect, useState } from 'react';
import Papa from 'papaparse';

const useFetchData = (csvFilePath: string) => {
  const [data, setData] = useState<any[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(csvFilePath);
        if (!response.ok) throw new Error('Network response was not ok');
        const csvData = await response.text();
        Papa.parse(csvData, {
          header: true,
          complete: (results) => {
            console.log('Parsed CSV data:', results.data); // Debugging line
            setData(results.data);
          },
        });
      } catch (error) {
        console.error('Error fetching data:', error); // Debugging line
      }
    };

    fetchData();
  }, [csvFilePath]);

  return data;
};

export default useFetchData;
